<template>
  <div class="wy-auto-qa-ai-evaluation-page" id="wy-auto-qa-ai-evaluation-print">
    <div v-if="showModal" class="modal-wrapper" >
      <div class="modal-body">
        <div class="flex-1 icon"></div>
        <div class="flex-9">
          <div class="h-100">
            <div class="fw-500">Unable to save</div>
            <span class="details">The changes you made to the score were unable to save. Please try again.</span>
          </div>
          <div class="flex-end"><button @click="showModal = false">Ok</button></div>
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-shadow" />

    <div v-if="hasFormDropdownData && isValidConversation" class="select-wrapper" @mouseover="handleSelectHover(true)" @mouseout="handleSelectHover(false)" @click="handleSelectFocus(false)">
      <span class="select-title">Choose Evaluation</span>
      <el-select
        ref="formSelect"
        class="form-select"
        popper-class="form-select-popper"
        v-model="formId"
        default-first-option
        @focus="handleSelectFocus(true)"
        @blur="handleSelectFocus(false)"
        @change="(formId) => handleSelectChange(formId)"
      >
        <el-option
          v-for="item in formListData"
          :key="item.formId"
          :label="item.formName"
          :value="item.formId">
        </el-option>
      </el-select>
    </div>

    <div v-if="hasFormData && isValidConversation" class="page-wrapper">
      <div class="formSection" v-loading="formSectionLoading">
        <div class="header" @click="handleSelectFocus(false)" >
          <span class="score-title">FINAL FORM SCORE</span>
          <div class="div-score-section">
            <div class="form-score">
              <span v-if="isAnySectionLoading()" v-loading="true" class="form-section-question-loading"></span>
              <span v-else-if="data && data.formScore != null" class="final-score-text">{{ data.formScore == '-1' ? 'N/A' : Number(data.formScore).toFixed(2) }}</span>
              <span v-else class="final-score-text">-</span>
              <el-tooltip v-if="data.isFormKpiFailed" ref="tooltip-kpi" class="tooltip-kpi" effect="dark" content="This form has not met the required KPI criteria." 
                placement="bottom" popper-class="form-tooltip-kpi-popper">
                <span class="span-kpi-btn isKpiFailed">KPI</span>
              </el-tooltip>
            </div>
            <div class="form-target-section">
              <span class="form-target-range">
                <span v-if="data.formTargetEnabled" class="form-target-value">Target: {{ data.formTarget }}</span>
                <span v-else class="form-target-value">&nbsp;</span>
                <span v-if="data.formTargetMessage" class="form-target-text">{{ data.formTargetMessage }}</span>
                <span v-else class="form-target-text">&nbsp;</span>
              </span>
            </div>
          </div>
        </div>
    
        <div v-if="data && data.sections && data.sections.length" class="section-wrapper" @click="handleSelectFocus(false)">
          <div v-for="(section, sectionIndex) in data.sections" :key="sectionIndex" class="section">
            <div class="section-header">
              <div class="div-section-title">
                <el-tooltip
                  popper-class="section-name-popper"
                  ref="tooltip-sectionName"
                  :disabled="!overflowStates[sectionIndex]"
                  placement="top-start"
                  :content="section.title"
                >
                  <div :ref="'sectionTitle' + sectionIndex" class="section-title">
                    SECTION {{ sectionIndex + 1 }}: {{ section.title }}
                  </div>
                </el-tooltip>
                <span v-if="section.weight==null" class="section-evaluation">&nbsp;</span>
                <span v-else class="section-evaluation">Worth {{ Number(section.weight).toFixed(2) }}% of evaluation</span>
              </div>
              <div class="section-score">
                <div class="div-score">
                  <span class="score-title">Section Score</span>
                  <span v-if="!isAnyQuestionLoading(section)" class="larger-font">{{ (section.status==='No Data') ? '-' : (section.score == '-1') ? 'N/A' : Number(section.score).toFixed(2) }}</span>
                  <span v-else-if="section.isSectionKpiFailed" class="larger-font">0.00</span>
                  <span v-else-if="isAnyQuestionLoading(section)" v-loading="true" class="form-section-question-loading"></span>
                </div>
                <div class="div-target">
                  <span v-if="section.target == null" class="span-target">&nbsp;</span>
                  <span v-else class="span-target"> Target: {{ section.target }}</span>
                  <el-tooltip v-if="section.isSectionKpiFailed" ref="tooltip-kpi" class="tooltip-kpi" effect="dark" content="This section has not met the required KPI criteria." 
                    placement="bottom" popper-class="form-tooltip-kpi-popper">
                    <span class="span-kpi-btn isKpiFailed">KPI</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div v-if="section.status==='No Data'&&section.questions.length===0" class="no-metrics-available">
              No metrics available
            </div>
            <div v-else v-for="(question, questionIndex) in section.questions" :key="questionIndex" class="section-question">
                <span style="display: flex;">
                  <span style="width: 435px;">{{ sectionIndex + 1 }}.{{ questionIndex + 1 }} 
                    {{ question.title }}
                  </span> <span class="gray-font">{{ Number(question.weight).toFixed(2) }}%</span>
                  <el-tooltip v-if="isQuestionKpi(question)" ref="tooltip-kpi" class="tooltip-kpi" effect="dark" content="This is a KPI Question. Achieving the KPI criteria is required for the Section or Form to meet evaluation standards." 
                    placement="bottom" popper-class="form-tooltip-kpi-popper">
                    <span class="span-kpi-btn">KPI</span>
                  </el-tooltip>
                </span>
              
  
              <el-tooltip ref="tooltip-editScore" v-if="hasAutoQAWritePermission&&!isMetaDataAndSelectedOptionLabelIsNoData(question)" :disabled="question.isEditing || isMetaData(question)" class="item" effect="dark" content="Click edit to change your score" placement="bottom" popper-class="form-tooltip-popper">
                <!-- <div :class="{'label-wrapper': !isMetaData(question)}"> -->
                <div class="label-wrapper">
                  <div v-for="(option, index) in question.questionOptions" :key="index">
                    <button 
                      @click="handleSelectNewOption(question, option.label)" 
                      class="label-btn" 
                      :class="{
                        'disabled': !question.isEditing, 
                        'selected': !isUserGeneratedComment(question) && option.label == question.selectedOptionLabel,
                        'newSelected': (isUserGeneratedComment(question) && option.label == question.selectedOptionLabel) || option.label == question.newSelectedOptionLabel,
                        'savedOptionLabel': option.label == question.savedOptionLabel,
                        'isKpi': question.isKpi
                      }" 
                      :disabled="!question.isEditing"
                    >
                      {{ option.label == 'NA' ? "N/A" : option.label }}
                      <span v-if="option.points != '-1'">({{ option.points }}%)</span>
                    </button>
                  </div>
                  <span style="color: red" v-if="!question.questionOptions || question.questionOptions.length == 0">No options</span>
                  <!-- <span v-if="isMetaData(question)">{{ question.selectedOptionLabel == "NA" ? "N/A" : question.selectedOptionLabel }} <span v-if="question.selectedOptionPoint != '-1'">({{ question.selectedOptionPoint }}%)</span></span> -->
                </div>
              </el-tooltip>
              <div v-else-if="!isMetaDataAndSelectedOptionLabelIsNoData(question)">
                <span>{{ question.selectedOptionLabel == "NA" ? "N/A" : question.selectedOptionLabel }} <span v-if="question.selectedOptionPoint != '-1'">({{ question.selectedOptionPoint }}%)</span></span>
              </div>
              
              
              <div v-if="!question.isLoading" class="reason">
                <div :class="{'wy-ai-icon': showAIIcon(question)}">{{ getCommentType(question) }}
                  {{ !isMetaDataAndSelectedOptionLabelIsNoData(question) ? 
                    formatQuestionReason(question.reason) : 'No metric available'}}
                </div>
                <div v-if="question.explanatoryMsgBeginTimeMs&&data.channel==='voice'">
                  <span class="reason-location-label">Location: </span><span class="reason-location" @click="handleLocationClick(question.explanatoryMsgBeginTimeMs)">{{ locationTime(question.explanatoryMsgBeginTimeMs) }}</span>
                </div>
              </div>
              <span v-else v-loading="true" class="form-section-question-loading"></span>
              <div v-if="hasAutoQAWritePermission && !question.isEditing && !isMetaData(question) && question.questionOptions && question.questionOptions.length > 0">
                <el-tooltip v-if="String(question.questionType).toUpperCase() === 'PHRASE_MATCH'" effect="dark" content="Editing is disabled for Phrase Match" placement="bottom" popper-class="form-tooltip-popper">
                <span class="edit-score edit-disabled" >Edit</span>
                </el-tooltip>
                <span v-else class="edit-score" @click="handleEditSection(question)" data-testid="App-Recordings-MediaPlayer-Evaluation-autoTab-EditScoreButton" >Edit</span>
              </div>
              <div v-else-if="question.isEditing" class="isEditing">
                <div class="body">
                  <el-input
                    class="input-box"
                    :class="{'max': getNewReasonLength(question) > MAX_CHARACTERS }"
                    type="textarea"
                    autosize
                    placeholder="User can write a comment"
                    v-model="question.newReason"
                    resize="none"
                    :maxlength="3000"
                    @input="handleTextInput($event, question)"
                    >
                  </el-input>
                  <span class="remaining" :class="{'warning': getNewReasonLength(question) > MAX_CHARACTERS }">
                    {{ getRemainingReasonCharacters(question) }}
                  </span>
                  <span v-if="data.channel&&data.channel==='voice'&&question.explanatoryMsgBeginTimeMs" class="location">
                    <span v-if="c1SelectedMessageTimeMs">
                      Location: <span class="reason-location">{{ locationTime(c1SelectedMessageTimeMs) }}</span>
                    </span>
                    <span v-if="!c1SelectedMessageTimeMs">
                      Location: <span class="reason-location">{{ locationTime(question.explanatoryMsgBeginTimeMs) }}</span>
                    </span>
                    <div class="location-desc">Choose a text from the transcript on the left to update the location.</div>
                  </span>
                  <span v-else-if="data.channel&&data.channel==='voice'" class="location">
                    <span> Location:
                      <span class="reason-location">
                        {{ c1SelectedMessageTimeMs ? locationTime(c1SelectedMessageTimeMs) : "" }}
                      </span>
                    </span>
                    <div class="location-desc">Choose a text from the transcript on the left to update the location.</div>
                  </span>
                  <div class="actions">
                    <button class="btn cancel" @click="handleCancelEdit(question)">Cancel</button>
                    <button class="btn save" :disabled="isSaveScoreDisabled(question)" :class="{'disabled': isSaveScoreDisabled(question)}" @click="handleSaveEdit(question)">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!isValidConversation" class="invalid-conversation-wrapper">
      <div class="title-wrapper"><span class="info-icon"></span><div class="title">Unable to provide a score</div></div>
      <div class="font-red">
        {{ invalidConversationReason }}
      </div>
    </div>
    <div v-else class="no-data-wrapper" v-loading="formSectionLoading" @click="handleSelectFocus(false)">
      <div class="no-data-text">No metrics available</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import WyConstants from "../../library/wy-constants";
import {print} from '@hvuejs/vue-print-js';
import WyUtils from "../../library/wy-utils";

export default Vue.extend({
  name: "wy-auto-ai-evaluation",
  data() {
    return {
      MAX_CHARACTERS: 3000,
      showModal: false,
      conversationId: null,
      invalidConversationReason: null,
      formId: null,
      formListData: [],
      data: null,
      dataCache: {}, // cached form data
      formSectionLoading: false,
      overflowStates: {}, // this is an ugly workaround but works,
      c1SelectedMessageTimeMs: null,
      c1CallDuration: null
    };
  },
  computed: {
    ...mapGetters(["authUser", "isRoleAllow"]),

    hasAutoQAPermission() {
      // Auto QA 4700
      return this.isRoleAllow(4700)
    },

    hasAutoQAWritePermission() {
      // Auto QA 4701
      return this.isRoleAllow(4701)
    },

    hasFormDropdownData() {
      return this.formListData && this.formListData.length > 0;
    },

    hasFormData() {
      return this.data && Object.keys(this.data).length > 0 && this.data.hasData;
      // return this.data && this.data.hasData //?
    },

    isValidConversation() {
      return this.invalidConversationReason == null;
    },

    selectedFormName() {
      const selectedForm = this.formListData.find(item => item.formId==this.formId);
      return selectedForm ? selectedForm.formName : "";
    }
  },
  methods: {
    ...mapActions(["fetchAutoQAEvalFormDropdown","fetchAutoQAEvalForm", "saveAutoQAEvalFormOverride", "postIFrameEvent"]),

    getFormatTarget(target) {
      return Vue.WyUtils.formatterFloatNumber(target)
    },

    isQuestionKpi(question) {
      return question.questionOptions && question.questionOptions.some(option => option.isKpi === true);
    },

    async fetchFormListDropdown(conversationId) {
      if (!this.hasAutoQAPermission) return false;

      const result = await this.fetchAutoQAEvalFormDropdown({ conversationId: conversationId, pageName: 'mediaPlayer' });

      if (result.status != 200) {
        console.error("Failed to fetch form list data");
        return false;
      }

      if (result.data && result.data.length == 0) return false;

      this.formListData = result.data;
      if(!this.formId) {
        this.formId = result.data && result.data[0] && result.data[0].formId;
      }

      return true;
    },

    async fetchFormData(conversationId, formId) {
      if (!this.hasAutoQAPermission) return false;

      if ((formId == null) && (conversationId == null)) {
        console.error("Invalid formId or conversationId");
        return false;
      }

      // Check if the form data is already cached
      if (this.dataCache[formId]) {
        this.data = this.dataCache[formId];
        return (this.data && this.data.sections && this.data.sections.length > 0);
      }

      const result = await this.fetchAutoQAEvalForm({ conversationId, formId });
      // result.data.sections.forEach(section => {
      //   section.title = "123456789012345678901234567890123456789012345678901234567890";
      //   section.target = 90
      // })
      // result.data.showTargetRange = true;
      // result.data.formTarget = 70;
      // result.data.formScore = -1;
      // result.data.formTargetMessage = 'Needs improvement toNeeds improvement to';
      // result.data.formTargetMessage = "Exceeds expectations"
      // result.data.formTargetEnabled = true
      // result.data.targetScoringRanges = [
      //   "Needs improvement",
      //   "Meets expectations",
      //   "Exceeds expectations"
      // ]
      if (result.status != 200) {
        console.error("Failed to fetch form data");
        return false;
      }
      if (result.data && result.data.isInvalidConversation) {
        this.invalidConversationReason = result.data.invalidReason;
        // need to set true, to show the Auto Evaluation section/panel and render the invalid conversation message
        return true;
      }

      // Preserve editing state and reason for each question
      if (this.data && this.data.sections) {
        result.data.sections.forEach((section, sectionIndex) => {
          section.questions.forEach((question, questionIndex) => {
            const currentSection = this.data.sections[sectionIndex];
            if (currentSection) {
              const currentQuestion = currentSection.questions[questionIndex];
              if (currentQuestion && currentQuestion.isEditing) {
                // Preserve isEditing and newReason
                question.isEditing = currentQuestion.isEditing;
                question.newReason = currentQuestion.newReason;
                question.newSelectedOptionLabel = currentQuestion.newSelectedOptionLabel;
                question.selectedOptionLabel = currentQuestion.selectedOptionLabel;
                question.originalSelectedOptionLabel = currentQuestion.originalSelectedOptionLabel;
              }
            }
          });
        });
      }
      
      // Cache the fetched data
      this.$set(this.dataCache, formId, result.data);

      this.data = result.data

      return (this.data && this.data.hasData);
    },

    isMetaData(question) {
      return question.evaluatorType == 'METADATA'
    },

    isMetaDataAndSelectedOptionLabelIsNoData(question) {
      return this.isMetaData(question) && question.selectedOptionLabel==='No Data';
    },

    isSaveScoreDisabled(question) {
      if (this.isAnySectionLoading()) return true;

      return this.getNewReasonLength(question) == 0 || this.getNewReasonLength(question) > this.MAX_CHARACTERS
    },

    locationTime(milliseconds) {
      return Vue.WyUtils.formatTimeBySeconds(milliseconds, false);
    },

    handleLocationClick(milliseconds) {
      this.postIFrameEvent({channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, action: 'AutoQA.Transcription.setMessageTime', time: milliseconds });
    },

    checkOverflowStates() {
      const ref = this.$refs.formSelect;
      if(ref) {
        ref.visible= false
      }
      this.data && this.data.sections && this.data.sections.forEach((_, index) => {
        const el = this.$refs[`sectionTitle${index}`] && this.$refs[`sectionTitle${index}`][0]; // Access the correct DOM element
        if (el) {
          this.$set(this.overflowStates, index, el.scrollWidth > el.clientWidth);
        }
      });
    },

    getRemainingReasonCharacters(question) {
      if (this.getNewReasonLength(question) > this.MAX_CHARACTERS) {
        return `You have surpassed the maximum character limit (${this.MAX_CHARACTERS}).`;
      } else {
        return `${this.MAX_CHARACTERS - this.getNewReasonLength(question)} characters remaining`;
      }
    },

    handleEditSection(question) {
      this.$set(question, 'isEditing', true);
    },

    handleSelectNewOption(question, newOption) {
      if (newOption == question.selectedOptionLabel) {
        this.$set(question, 'newSelectedOptionLabel', null);
        return;
      }
      this.$set(question, 'newSelectedOptionLabel', newOption);

      if (!question.originalSelectedOptionLabel) {
        this.$set(question, 'originalSelectedOptionLabel', question.selectedOptionLabel);
        this.$set(question, 'selectedOptionLabel', null);
      }
    },

    handleCancelEdit(question) {
      this.$set(question, 'isEditing', false);
      this.$set(question, 'newReason', '');
      this.$set(question, 'newSelectedOptionLabel', null);
      this.$set(question, 'selectedOptionLabel', question.originalSelectedOptionLabel || question.selectedOptionLabel);
      this.$set(question, 'originalSelectedOptionLabel', null);
      this.c1SelectedMessageTimeMs = null;
    },

    async handleSaveEdit(question) {
      this.$set(question, 'isEditing', false);
      this.$set(question, 'selectedOptionLabel', question.originalSelectedOptionLabel || question.selectedOptionLabel);
      let maxOptionPoints = null;
      question.questionOptions.forEach(option => {
        maxOptionPoints = Math.max(maxOptionPoints, option.points);
      })
      this.$set(question, 'maxOptionPoints', maxOptionPoints);
      this.$set(question, 'selectedOptionLabel', question.newSelectedOptionLabel || question.selectedOptionLabel);
      const selectedLabel = question.newSelectedOptionLabel || question.selectedOptionLabel;
      const newReason = question.newReason;
      const questionOptionsSelected = question.questionOptions.find(option => option.label == selectedLabel);
      const hasKpiOption = question.questionOptions.some(option => option.isKpi === true);
      const isKpi = !hasKpiOption ? false : questionOptionsSelected.isKpi;
      let autoFailLevelOption = question.questionOptions.find(option => option.autoFailLevel != null);
      let autoFailLevel = isKpi && autoFailLevelOption ? autoFailLevelOption.autoFailLevel : null;


      this.$set(question, 'newSelectedOptionLabel', null);
      this.$set(question, 'newReason', '');
      // this.$set(question, 'originalSelectedOptionLabel', null);
      this.$set(question, 'isLoading', true);
      const result = await this.saveAutoQAEvalFormOverride({
        conversationId: this.conversationId,
        selectedOptionId: questionOptionsSelected.id,
        questionId: question.id,
        resultId: question.resultId,
        reason: newReason,
        explanatoryMsgBeginTimeMs: this.c1SelectedMessageTimeMs,
        explanatoryMsgEndTimeMs: this.c1SelectedMessageTimeMs, // we don't have the end time, so use the begin time
        agentFirstName: this.authUser.user.firstName,
        agentLastName: this.authUser.user.lastName,
        agentId: this.authUser.user.id,
        updatedBy: this.authUser.user.email,
        maxOptionPoints: question.maxOptionPoints,
        evaluatorType: question.evaluatorType,
        realm: question.questionOptions.find(option => option.realm)?question.questionOptions.find(option => option.realm).realm:null,
        isKpi: isKpi,
        autoFailLevel: autoFailLevel,
      })

      const isSuccess = result && result.status == 200;

      if (isSuccess) {
        delete this.dataCache[this.formId]; // delete the cache so that the next fetch will get the latest data

        await this.fetchFormData(this.conversationId, this.formId);

        this.c1SelectedMessageTimeMs = null;
        this.postIFrameEvent({channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, action: 'AutoQA.AIAnalysis.reload', formId: this.formId || 0 });
      } else {
        this.$set(question, 'selectedOptionLabel', question.originalSelectedOptionLabel || question.selectedOptionLabel);
        this.showModal = true;
      }

      this.$set(question, 'originalSelectedOptionLabel', null);
      this.$set(question, 'isLoading', false);
    },

    isAnyQuestionLoading(section) {
      return section.questions && section.questions.length && section.questions.some(question => question.isLoading)
    },

    isAnySectionLoading() {
      return this.data && this.data.sections && this.data.sections.length && this.data.sections.some(section => this.isAnyQuestionLoading(section))
    },

    getNewReasonLength(question) {
      return question.newReason ? question.newReason.length : 0;
    },

    handleTextInput(input, question) {
      this.$set(question, 'newReason', input); // need this for reactivity

      const textarea = event.target;
      if (!question.newReason) {
        textarea.style.height = "16px";
        return;
      }
    },

    handleSelectHover(isHovered) {
      const hoveredStyle = '1px solid black'
      const unHoveredStyle = '1px solid #C6C6C6';

      const ref = this.$refs.formSelect;
      if (!ref) return;

      const isFocused = ref.$el.querySelector('.el-input').classList.contains('is-focus');
      if (isFocused) return;

      ref.$el.querySelector('.el-input').style.border = isHovered ? hoveredStyle : unHoveredStyle;
    },

    handleSelectFocus(isFocused) {
      const focusedColorStyle = '2px solid #013B5C';
      const unFocusedColorStyle = '1px solid #C6C6C6';

      const ref = this.$refs.formSelect;
      if (!ref) return;

      ref.$el.querySelector('.el-input').style.border = isFocused ? focusedColorStyle : unFocusedColorStyle;
      this.handleSelectTitleTransition(isFocused);

      if (isFocused) {
        this.$nextTick(() => {
          ref.$el.querySelector('.el-input').classList.add('is-focus');
        });
      } else {
        this.$nextTick(() => {
          ref.$el.querySelector('.el-input').classList.remove('is-focus');
          this.handleSelectHover(false);
        });

      }
    },

    handleSelectTitleTransition(isFocused) {
      const selectTitle = document.querySelector('.select-title');
      selectTitle.style.color = isFocused ? '#013B5C' : '#7D7D7D';
      selectTitle.style.transition = 'color 0.3s';
    },

    async handleSelectChange(formId) {
      this.handleSelectFocus(true);

      this.formId = formId;

      this.formSectionLoading = true;
      await this.fetchFormData(this.conversationId, formId);
      this.formSectionLoading = false;
      this.checkOverflowStates();
      this.postIFrameEvent({channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, action: 'AutoQA.AIAnalysis.reload', formId: formId});
      this.postIFrameEvent({channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, action: 'AutoQA.Transcription.setMessageTime', time: 0 });
    },

    isUserGeneratedComment(question) {
      return question.evaluatorId != null;
    },

    async c1MediaPlayerListener(event) {
      if (event.data.channel === WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER) {
        if (event.data.action === 'AutoQA.AutoEval.print') {
          print({
            id: "#wy-auto-qa-ai-evaluation-print",
            popTitle: this.selectedFormName,
          })
        }
        else if (event.data.action === 'AutoQA.AutoEval.setMessageTime') {
          this.c1SelectedMessageTimeMs = event.data.time;
          this.c1CallDuration = event.data.callDuration;
        }
      }
    },

    enhancedTitle(question) {
      return String(question.questionType).toUpperCase() === 'PHRASE_MATCH' 
      ? `Did the ${question.phraseMatchSentBy} say "` + question.title + '"'
      : question.title;
    },

    getCommentType(question) {
      if( this.isUserGeneratedComment(question)) {
        return "User comment: ";
      }
      else if (String(question.questionType).toUpperCase() === 'PHRASE_MATCH') {
        if(String(question.evaluatorType).toUpperCase() === "EXACT") {
          return "Exact Phrase Match: ";
        } else if (String(question.evaluatorType).toUpperCase() === "AI") {
          return "AI Phrase Match: ";         
        }
      } else {
        return "AI comment: ";
      }
    },

    showAIIcon(question) {
      if(this.isUserGeneratedComment(question)) {
        return false;
      } 
      else if(String(question.evaluatorType).toUpperCase() === "AI") {
        return true;
      } else {
        return false;
      }
    },

    formatQuestionReason(reason) {
      if(WyUtils.isValueInArray(reason, ['',null,undefined])) return '';

      return WyUtils.isValueInArray(reason, ['No match found.']) ? reason : `"${reason}"`;
    }

  },

  async created() {
    this.$router.app.setIFrameLoading(true); // the routerAq.js is not loading the iFrame when first opened
    this.conversationId = this.$route.query.contactId;
    
    window.addEventListener('message', this.c1MediaPlayerListener);

    const showDropdownData = await this.fetchFormListDropdown(this.conversationId);

    let isFromDashboardPage = false;
    if(this.$route.query.formId > 0) {
      this.formId = parseInt(this.$route.query.formId)
    }
    else {
      // if formId was passed from the dashboard page and this formId exists in the form filter, 
      // then it selects this form and refresh Data Insights
      const selectedFormId = parseInt(window.localStorage.getItem(WyConstants.MEDIAPLAYER_AUTOQA_SELECTED_FORMID)) || 0; //3903
      if(selectedFormId) {
        window.localStorage.removeItem(WyConstants.MEDIAPLAYER_AUTOQA_SELECTED_FORMID);
        if(this.formListData && this.formListData.find(item => item.formId==selectedFormId)) {
          this.formId = selectedFormId;
          isFromDashboardPage = true;
        }
      }
    }

    const showFormData = await this.fetchFormData(this.conversationId, this.formId);

    if(isFromDashboardPage) {
      this.postIFrameEvent({channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, action: 'AutoQA.AIAnalysis.reload', formId: this.formId});
    }

    this.$router.app.setIFrameLoading(false);
    this.postIFrameEvent({ 
      channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, 
      action: 'AutoQA.AutoEvaluation.enable', hasData: Boolean(showDropdownData || showFormData) 
      // Note: For invalid conversations, the showDropdownData (/formFilter) will return [].
      // showFormData will be set to true because the /aiEvalResult returns the invalidConversationReason.
    });

    this.$nextTick(this.checkOverflowStates());
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.checkOverflowStates();
    });

    const thisPage = document.querySelector('.wy-auto-qa-ai-evaluation-page')
    thisPage.addEventListener('scroll', () => {
      const sectionNameTooltips = this.$refs['tooltip-sectionName'] && this.$refs['tooltip-sectionName']
      const editScoreTooltips = this.$refs['tooltip-editScore'] && this.$refs['tooltip-editScore']

      if (Array.isArray(sectionNameTooltips)) {
        sectionNameTooltips.forEach(tooltip => {
          tooltip.hide()
          tooltip.handleClosePopper()
          tooltip.handleBlur();
          tooltip.doDestroy();
        })
      } else if (sectionNameTooltips) {
        sectionNameTooltips.hide()
        sectionNameTooltips.handleClosePopper()
        sectionNameTooltips.handleBlur();
        sectionNameTooltips.doDestroy();
      }

      if (Array.isArray(editScoreTooltips)) {
        editScoreTooltips.forEach(tooltip => {
          tooltip.hide()
          tooltip.handleClosePopper()
          tooltip.handleBlur();
          tooltip.doDestroy();
        })
      } else if (editScoreTooltips) {
        editScoreTooltips.hide()
        editScoreTooltips.handleClosePopper()
        editScoreTooltips.handleBlur();
        editScoreTooltips.doDestroy();
      }
    });
  },

  destroyed() {
    window.removeEventListener('message', this.c1MediaPlayerListener);
  },
});
</script>

<style lang="scss">
.wy-auto-qa-ai-evaluation-page {

  overflow-y: scroll;
  overflow-x: hidden;

  @media print {
    -webkit-print-color-adjust: exact;
  }

  .el-loading-spinner {
    top: 8% !important;
  }

  font-weight: 400;
  line-height: 18.75px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  background-color: #efeef7;

  .page-wrapper {
    height: 100%;
    .formSection {
      .el-loading-mask {
        background-color: transparent !important;
      }
    }
  }

  .select-wrapper {
    background-color: white;
    padding: 16px;
    height: 40px;
    position: sticky;

    .select-title {
      position: absolute;
      background-color: white;
      z-index: 1;
      margin-left: 14px;
      margin-top: -8px;
      font-size: 0.75rem;
      color: #7D7D7D;
      padding: 0px 4px;
    }
  }

  .form-select {
    width: 100%;
    
    .el-input {
      border: 1px solid #C6C6C6;
      border-radius: 4px;
    }

    .is-focus {
      border: 2px solid #013B5C;
    }

    input.el-input__inner {
      border: none;
      background: transparent;
      padding-left: 16px;
      color: black;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      overflow: hidden !important;
    }

    input::-webkit-input-placeholder {
      color: black;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    background: #D5F3FD;
    // border-bottom: 0.5px solid var(--gray-80-charcoal, #64727c);

    padding: 10px 16px 3px 16px;
    flex-direction: column;
    position: sticky;
    top: 0px;
    width: 100%;
    z-index: 98;
    height: 58px;
    .div-score-section {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }
    .form-target-range {
      display: flex;
      flex-direction: column;
      margin-right: 25px;
    }
    .form-target-section { 
      position: relative;
      top: -3px;
    }
    .form-score {
      display: flex;
      align-items: flex-end;
      align-items: center;
      margin-top: 7px;
      .span-kpi-btn {
        background-image: var(--form-media-player-KPI-danger-icon);
        background-repeat: no-repeat;
        background-position-x: 5px;
        background-position-y: 4px;
        background-color: #5EB2C5;
        border-radius: 5px;
        min-width: 34px;
        text-align: right;
        padding: 3px 10px;
        margin-left: 20px;
        font-size: 12px;
        cursor: pointer;
        // position: relative;
        // top: 3px;
      }
      .isKpiFailed {
        color: white !important;
        background-image: var(--form-media-player-KPI-danger-icon-white);
        background-color: #A8071A;
      }
    }
    span.score-title {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1px;
    }
    .final-score-text {
      font-weight: 500;
      font-weight: bold;
    }
    span.final-score-text {
      font-size: 32px; 
      font-weight: 900;
    }
    .form-target-text {
      font-style: italic;
      font-size: 12px;
      font-weight: 400;
      max-width: 138px;
      width: calc(100% + 5px);
      // min-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .form-target-value {
      font-size: 12px;
      font-weight: 700;
    }
  }

  .section-wrapper {
    height: 90%; // iframe gets cut on c1
    overflow-y: auto;
    background-color: white;

    .section:last-child {
      margin-bottom: 0;
    }

    .section {
      // padding: 20px 16px;
      margin: 20px 16px;
      margin-bottom: 18px;
      padding-bottom: 15px;
      background-color: white;
      font-size: 14px;
      overflow-y: auto;
      border-bottom: 1px solid #000;
  
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
  
        font-weight: 500;
        font-weight: bold;
        margin-bottom: 6px;
        // padding-bottom: 8px;
        // border-bottom: 1px solid #CCC;
        .div-section-title {
          width: calc(100% - 165px);
        }
        .section-title {
          font-size: 0.875rem;
          line-height: 1.75;
          letter-spacing: 0.02857em;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .section-score {
          font-size: 0.825rem;
          display: flex;
          align-items: center;
          gap: 6px;
          // min-width: 150px;
          height: 50px;
          min-width: 150px;
          padding: 5px;
          border: 1px solid #D5F3FD;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .div-score{
            display: flex;
            flex-direction: column;
            gap: 8px;
            height: 48px;
            .score-title {
              font-size: 10px;
              font-weight: 700;
              letter-spacing: 1px;
            }
            .larger-font {
              font-size: 24px;
              font-weight: 500;
            }
          }
          .div-target{
            display: flex;
            flex-direction: column;
            gap: 4px;
            height: 48px;
            .span-target {
              font-size: 10px;
              font-weight: 600;
            }
            .span-kpi-btn {
              background-image: var(--form-media-player-KPI-danger-icon);
              background-repeat: no-repeat;
              background-position-x: 5px;
              background-position-y: 4px;
              background-color: #5EB2C5;
              border-radius: 5px;
              min-width: 34px;
              text-align: right;
              padding: 3px 10px;
              font-size: 12px;
              cursor: pointer;
            }
            .isKpiFailed {
              color: white !important;
              background-image: var(--form-media-player-KPI-danger-icon-white);
              background-color: #A8071A;
            }
          }
        }
  
        .larger-font {
          font-size: 0.975rem;
          font-family: "Roboto", "Helvetica", "Arial", sans-serif;
          // line-height: 1.43;
          letter-spacing: 0.01071em;
        }
      }
  
      .section-evaluation {
        color: #64727c;
        font-size: 0.75rem;
        font-weight: 400;
        line-height: 1.66;
        letter-spacing: 0.03333em;
        font-style: italic;
      }
      .no-metrics-available {
        font-weight: 600;
        padding-top: 20px;
      }
  
      .section-question {
        display: flex;
        flex-direction: column;
        gap: 12px;
  
        margin-top: 10px;
        border-top: 1px solid #CCC;
        padding-top: 10px;
  
        font-weight: bold;
        font-size: 0.875rem;
        font-family: "Roboto", "Helvetica", "Arial", sans-serif;
        line-height: 1.43;
        letter-spacing: 0.01071em;

        .label-wrapper {
          display: flex;
          gap: 8px;
          margin-bottom: 4px;
          max-width: max-content;
          flex-wrap: wrap;

          .label-btn {
            background-color: transparent;
            border: none;
            border-radius: 4px;
            padding: 6px 10px;
            border: 1px solid #869DAE;
            color: #013B5C;
            cursor: pointer;
          }
          .disabled {
            background-color: #F5F5F5;
            border: 1px solid #D9D9D9;
            color: #a1a0a0;
            cursor: not-allowed;
          }
          .selected {
            background-color: #013B5C;
            color: white;
            transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          }
          .newSelected {
            background-color: #6D92FE;
            // background-color: #013B5C;
            color: #000;
            transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
          }
          .savedOptionLabel.newSelected.isKpi, .savedOptionLabel.selected.isKpi {
            background-color: #A8071A;
            color: white !important;
            background-image: var(--form-media-player-KPI-danger-icon-white);
            background-repeat: no-repeat;
            background-position-x: 10px;
            background-position-y: 5px;
            padding-left: 30px;
            width: fit-content;
          }
        }
        .span-kpi-btn {
          background-image: var(--form-media-player-KPI-danger-icon);
          background-repeat: no-repeat;
          background-position-x: 5px;
          background-position-y: 4px;
          background-color: #5EB2C5;
          border-radius: 5px;
          min-width: 34px;
          text-align: right;
          padding: 4px 10px 3px 10px;
          font-size: 12px;
          height: 18px;
          margin-left: 5px;
          position: relative;
          top: -3px;
          cursor: pointer;
        }
        .gray-font {
          font-weight: 400;
          color: #64727c;
        }

        .edit-score {
          font-size: 0.8rem;
          font-weight: 400;
          text-decoration: underline;
          text-decoration-thickness: 1px;
          text-decoration-color: #013B5C;
          text-underline-offset: 2px;
          color: #013B5C;
          width: max-content;
          cursor: pointer;
        }

        .edit-disabled{
          opacity: 0.5;
        }

        .isEditing {
          background-color: #F3F9FF;
          margin: 0px -16px;

          .body {
            padding: 12px 16px;
            display: flex;
            flex-direction: column;
          }

          .input-box {
            border-radius: 4px;
            font-size: 0.8rem;
            font-weight: 400;
            min-height: 16px; /* Minimum height */
            margin-bottom: 8px;
            width: auto;
            margin: 0px 15px 0px 8px;
          }

          .max {
            textarea {
              border: 1px solid red;
            }
          }

          // remove stylers for el-input focus
          .el-input__inner:focus {
            outline: none;
            box-shadow: none;
          }

          textarea {
            font-family: "Roboto", "Helvetica", "Arial", sans-serif;
            font-size: 0.9rem;
            font-weight: 400;
            line-height: 1.5;
            resize: none;
          }
          
          .remaining {
            font-weight: 400;
            font-size: 0.7rem;
            margin-top: 2px;
            margin-left: 8px;
          }
          
          .location {
            font-weight: 400;
            font-size: 0.8rem;
            margin-left: 8px;
            margin-top: 8px;
            font-size: 0.8rem;
            font-weight: 400;
            font-style: italic;
            .location-desc {
              margin-top: 5px;
              font-style: normal;
              // margin-left: 5px;
            }
              
          }

          .warning {
            color: red;
          }

          .actions {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 16px;
            margin-right: 15px;
            margin-top: 5px;

            .btn {
              background-color: transparent;
              border: none;
              font-size: 0.8rem;
              cursor: pointer;
            }

            .cancel {
              // font-weight: bold;
              text-decoration: underline;
            }

            .save {
              color: white;
              background-color: #013B5C;
              border: 1px solid #013B5C;
              padding: 5px 16px;
              font-weight: 400;
              border-radius: 4px;
            }

            .disabled {
              background-color: #F5F5F5;
              border: 1px solid #D9D9D9;
              color: #a1a0a0;
              cursor: not-allowed;
            }
          }
        }
  
        .reason {
          font-size: 0.8rem;
          font-weight: 400;
          font-style: italic;
          // color: #1F2CA2;
        }

        .reason-location-label {
          font-size: 0.8rem;
          font-weight: 400;
          font-style: italic;
        }

        .reason-location {
          font-size: 0.8rem;
          font-style: italic;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }
        .isEditing .reason-location {
          text-decoration: none;
          cursor: default;
          font-weight: 600;
          color: #1F2CA2;
        }
      }
    }
  }

  .invalid-conversation-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 20px;
    gap: 12px;
    text-align: center;
    background-color: white;
    height: 100%;
    overflow: hidden;

    .title-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 40px;
    }

    .info-icon {
      background-image: url('../../assets/icons/icon_info.svg');
      background-repeat: no-repeat;
      width: 20px;
      height: 20px;
      filter: invert(0.5) sepia(1) saturate(10000%) hue-rotate(0deg) brightness(1);
      margin-top: -2px;
    }

    .title {
      font-weight: 500;
      font-weight: bold;
    }

    .font-red {
      color: red;
      font-size: 0.9rem;
    }
  }

  .no-data-wrapper {
    width: 100%;
    height: 200px;

    .no-data-text {
      font-size: 18px;
      background-color: white;
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
    }
  }

  .modal-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.2;
    display: flex;
    z-index: 99;
  }

  .modal-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .modal-body {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    background-color: white;
    margin: 0px 30px;
    margin-top: 50px;
    padding: 40px 30px 30px 30px;
    border-radius: 2px;
    height: 130px;
    z-index: 9999;
    display: flex;
    flex: 1;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);

    .flex-1 {
      flex: 1;
      min-width: 30.5px;
    }

    .icon {
      background-image: url('../../assets/icons/icon_error_circle.svg');
      background-repeat: no-repeat;
    }

    .flex-9 {
      flex: 9;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .h-100 {
      height: 100%;
      margin-top: 4px;
    }

    .fw-500 {
      font-weight: 500;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .details {
      font-size: 0.9rem;  
      line-height: 1.5;
    }

    .flex-end {
      display: flex;
      justify-content: flex-end;
    }

    button {
      background-color: #1890FF;
      color: white;
      padding: 8px 16px;
      font-weight: 400;
      border-radius: 4px;
      border: none;
      cursor: pointer;
    }
  }
}

.form-select-popper {
  width: 50% !important; // need to overwrite so that element io component does not assign default min width
  .el-select-dropdown__item {
    color: black !important
  }

  .selected {
    font-weight: 400 !important;
  }
}

.form-tooltip-popper {
  padding: 4px 6px !important;
  margin-top: 6px !important;
}

.form-tooltip-kpi-popper {
  padding: 4px 6px !important;
  margin-top: 6px !important;
  max-width: 198px !important;
  text-align: center;
}

.section-name-popper {
  max-width: 80% !important;
}

.form-section-question-loading {
  z-index: 10;
  width: 20px !important;
  height: 20px !important;
  margin-right: 4px;
  .el-loading-spinner {
    height: 20px !important;
    width: 20px !important;
    scale: 0.3 !important;
    margin-top: -14px !important;
  }
}

.wy-ai-icon {
  background: var(--question-editor-stars-icon-white);
  background-repeat: no-repeat;
  padding-left: 28px;
  display: flex;
  align-items: center;
  min-height: 24px;
}
</style>
